import { categories } from '@/mocks/campusData';

export function catOf(key: string) {
  return categories.find((c) => c.key === key) ?? categories[0];
}

export function Badge({ catKey, className = '' }: { catKey: string; className?: string }) {
  const cat = catOf(catKey);
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${cat.tone} ${className}`}
    >
      <i className={`${cat.icon} text-[11px]`} />
      {cat.name}
    </span>
  );
}

export function SectionHeading({
  kicker,
  title,
  desc,
}: {
  kicker?: string;
  title: string;
  desc?: string;
}) {
  return (
    <div className="mb-8 md:mb-10">
      {kicker && (
        <p className="mb-2 flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-red-600">
          <span className="inline-block h-px w-6 bg-red-500" />
          {kicker}
        </p>
      )}
      <h2 className="font-editorial text-2xl font-black leading-snug text-stone-900 md:text-3xl">
        {title}
      </h2>
      {desc && <p className="mt-3 max-w-2xl text-sm leading-relaxed text-stone-500 md:text-base">{desc}</p>}
    </div>
  );
}